export class DeleteBackupPolicy201Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaRequest",
            "baseName": "mpaRequest",
            "type": "MPARequest",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DeleteBackupPolicy201Response.attributeTypeMap;
    }
    constructor() {
    }
}
